import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function urlB64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupport() {
  const supported = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const standalone =
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  return { supported, needsInstall: isIOS && !standalone };
}

export async function getPushStatus() {
  const { supported, needsInstall } = pushSupport();
  if (!supported) return needsInstall ? "needs-install" : "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg && (await reg.pushManager.getSubscription());
    return sub ? "on" : "off";
  } catch {
    return "off";
  }
}

export async function enableOfficePush() {
  const { supported, needsInstall } = pushSupport();
  if (needsInstall) {
    throw new Error("On iPad: tap Share → Add to Home Screen first, then open the installed app and try again.");
  }
  if (!supported) throw new Error("This browser doesn't support push notifications.");

  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was not granted.");

  const reg = await navigator.serviceWorker.register("/service-worker.js");
  await navigator.serviceWorker.ready;

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await axios.get(`${API}/push/web/public-key`);
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.publicKey),
    });
  }
  await axios.post(`${API}/push/web/subscribe`, sub.toJSON());
  return sub;
}

export async function disableOfficePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (!sub) return;
  try { await axios.post(`${API}/push/web/unsubscribe`, { endpoint: sub.endpoint }); } catch { /* best effort */ }
  await sub.unsubscribe();
}

export async function sendTestPush() {
  const { data } = await axios.post(`${API}/push/web/test`, {});
  return data;
}
